const PATH_PREFIX = '/cart';

export default [
  {
    name: 'commerce.cart.index',
    path: `${PATH_PREFIX}/`,
  },
];
